import type { BaseProduct } from '@bulknutrients/bulk-shared-lib/interfaces/Product';
import { ProductCard } from '@components/ProductCard/ProductCard';

export function ProductList({ products }: { products: BaseProduct[] }) {
  return (
    <div>
      <div className="ga-search-list ga-search-products mx-auto grid w-fit grid-cols-1 gap-4 md:grid-cols-2 xl:grid-cols-3">
        {products.map((p, index) => (
          <ProductCard
            key={p.entityId}
            product={p}
            className={`gae-product-card-${index}`}
            location="Search Results Products List"
          />
        ))}
      </div>
    </div>
  );
}
